import Enum from "../../../../enums/Enum";

const InformedConsentYesNoEnum = new Enum({
    true: {name: "Yes", nameInArabic: "نعم"},
    false: {name: "No", nameInArabic: "لا"},

});

export default InformedConsentYesNoEnum;